import app from 'flarum/forum/app';
import { data, onCommunity } from '../common/community';

/**
 * "Your places" in the theme's left sidebar: a group just below the pinned links,
 * built with the theme's own markup so it looks and collapses like the others.
 * Each place links to its main tag (e.g. Toronto, Lagos, Kano).
 */
function esc(s) {
  return String(s).replace(/[&<>"']/g, c => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  })[c]);
}
export function ensurePlacesNav() {
  const nav = document.querySelector('.Voucha-groupedNav');
  if (!nav) return false;
  const existing = nav.querySelector('.VouchaPlacesNav');
  const d = data();
  const places = d.state === 'ok' ? d.places.filter(p => p.tags && p.tags.length) : [];
  if (!places.length) {
    if (existing) existing.remove();
    return true;
  }

  // on My Community itself the banner's chips list the same places, so the group steps aside there
  const hideHere = onCommunity();
  if (existing) existing.style.display = hideHere ? 'none' : '';
  let current = '';
  try {
    current = m.route.param('tags') || '';
  } catch (e) {}
  const sig = JSON.stringify(places.map(p => [p.key, p.label, p.tags[0]])) + '|' + current;
  if (existing && existing.getAttribute('data-sig') === sig) return true;
  const section = existing || document.createElement('div');
  section.style.display = hideHere ? 'none' : '';
  section.className = 'Voucha-navGroup VouchaPlacesNav';
  section.setAttribute('data-sig', sig);
  section.innerHTML = '<div class="Voucha-navGroup-heading"><span>Your places</span><i class="fas fa-chevron-down Voucha-navGroup-chevron"></i></div>' + '<div class="Voucha-navGroup-body">' + places.map(p => {
    const href = app.route('tag', {
      tags: p.tags[0]
    });
    return '<div class="Voucha-navItem"><div class="Voucha-navItem-row"><a class="Voucha-navLink' + (p.tags[0] === current ? ' is-active' : '') + '" href="' + esc(href) + '" title="' + esc(p.full) + '">' + '<i class="Voucha-navIcon ' + esc(p.icon) + '"></i><span class="Voucha-navLabel">' + esc(p.label) + '</span></a></div></div>';
  }).join('') + '</div>';

  // One handler on the group (survives rebuilds of its contents): collapse on heading click
  section.onclick = e => {
    if (e.target.closest('.Voucha-navGroup-heading')) section.classList.toggle('is-collapsed');
  };
  if (!existing) {
    const top = nav.querySelector('.Voucha-topLinks');
    nav.insertBefore(section, top ? top.nextSibling : nav.firstChild);
  }
  section.querySelectorAll('a.Voucha-navLink').forEach(a => {
    a.onclick = e => {
      if (e.ctrlKey || e.metaKey) return;
      e.preventDefault();
      m.route.set(a.getAttribute('href'));
    };
  });
  return true;
}